/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Component, inject, Input, OnInit } from '@angular/core';
import { PanelModule } from 'primeng/panel';
import { StyleClassModule } from 'primeng/styleclass';
import { TranslateModule } from '@ngx-translate/core';
import { FooterService } from './footer.service';
import { PlatformCompanyRegistrationDto } from '@well/platform-administration/company/shell';
import { RouterLink } from '@angular/router';
import {
  guestTermsAndConditionsPageUrl,
  loggedInTermsAndConditionsPageUrl,
  platformCompanyContactFormUrl
} from '@well/navigation';
import { AsyncPipe } from '@angular/common';
import { translationSchema } from '@well/translation';
import { NtpLogoComponent } from '../ntp-logo/ntp-logo.component';
import { LoggedInUser } from '@irian-ro/util-user';

@Component({
  selector: 'well-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  imports: [PanelModule, StyleClassModule, TranslateModule, RouterLink, AsyncPipe, NtpLogoComponent],
  standalone: true,
})
export class FooterComponent implements OnInit {
  platformCompanyRegistrationDTO: PlatformCompanyRegistrationDto | null = new PlatformCompanyRegistrationDto();
  footerService = inject(FooterService);
  @Input() loggedInUser: LoggedInUser | null = null;

  ngOnInit(): void {
    this.footerService
      .getActivePlatformLegalEntityTemplate()
      .subscribe(
        (platformLegalEntityDto) =>
          (this.platformCompanyRegistrationDTO = platformLegalEntityDto.data.companyRegistrationDTO)
      );
  }

  protected readonly platformCompanyContactFormUrl = platformCompanyContactFormUrl;
  protected readonly translationSchema = translationSchema;
  protected readonly loggedInTermsAndConditionsPageUrl = loggedInTermsAndConditionsPageUrl;
  protected readonly guestTermsAndConditionsPageUrl = guestTermsAndConditionsPageUrl;
}
